export const navigation: NavigationItem[] = [
  {
    path: '/locations',
    labelKey: 'NAVIGATION.LOCATIONS',
    icon: 'location_on'
  },{
    path: '/lockers',
    labelKey: 'NAVIGATION.LOCKERS',
    icon: 'inventory_2'
  },{
    path: '/parcels',
    labelKey: 'NAVIGATION.PARCELS',
    icon: 'local_shipping'
  },
  // Nova Post pilot has ended; the dashboard stays reachable at /novapost-kpis.
  // {
  //   path: '/novapost-kpis',
  //   labelKey: 'NAVIGATION.NOVAPOST_KPIS',
  //   icon: 'insights'
  // },
  // {
  //   path: '/users',
  //   labelKey: 'NAVIGATION.USERS',
  //   icon: 'people'
  // }
]

export interface NavigationItem {
  path: string;
  labelKey: string;
  icon?: string;
}
